import React, { useEffect, useState } from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import styled from "styled-components";
import { useScreenWidth } from "../../helper/screentWidth";

function IncomeSource({
  Title = "Current Income Source",
  Active = true,
  value = '',
  onChange,
}) {
  const [selectedNames, setSelectedNames] = useState("");
  const screenWidth = useScreenWidth();

  const options = [
    { key: "591930000", value: "1", text: "1099" },
    { key: "910310000", value: "2", text: "Stay at home" },
    { key: "910310001", value: "3", text: "Retired" },
    { key: "910310002", value: "4", text: "W2" },
    { key: "910310003", value: "5", text: "Both (1099 & W2)" },
    { key: "910310003", value: "6", text: "Unemployed" },
  ];

  useEffect(() => {
    if (value) {
      setSelectedNames(options.find(option => option.value === value.toString())?.text);
    } else {
      setSelectedNames("");
    }
  }, [value]);

  const handleChange = (event, data) => {
    onChange(data.value);
  };

  return (
    <Container>
      <FieldName>{Title}</FieldName>
          <CustomDropDown
            placeholder="Income Source"
            fluid
            search
            selection
            disabled={!Active}
            onChange={handleChange}
            value={value && value.toString()}
            options={options}
          />

    </Container>
  );
}

// Styled components
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr ;
  align-items: center;
  width: 100%;
  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    grid-template-columns: 1fr;
    gap: 10px;
    max-height: 100px;
  }
`;


const FieldName = styled.div`
  text-align: right;
    justify-self: start;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  font-style: italic;
  font-weight: 300;
  @media screen and (max-width: ${(props) =>
      props.firstmeeting ? "983px" : "690px"}) {
    padding: 20px 0px 0px 0px;
  }
`;


const Text = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  min-width: 120px;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;

  min-height: 36px;
`;

const CustomDropDown = styled(Dropdown)`
  background: var(--editable) !important;
  border: none !important;
  width: 100%;

  &.ui.selection.dropdown {
    min-height: 30px !important;
    height: 30px !important;
    border-radius: 20px !important;
    padding: 0 35px 0 10px !important; /* Match padding-left: 10px */
    line-height: 30px !important;
    
    color: #304961 !important;
    font-family: "Museo Sans Cyrl" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border: none !important;
    outline: none !important;
  }

  &.ui.disabled.dropdown {
    opacity: 0.5 !important;
  }

  & > .text,
  & > .default.text {
    line-height: 30px !important;
    padding: 0 !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #304961 !important;
  }

  & > .default.text {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #8a9ba8 !important;
  }

  & input.search {
    padding: 0 !important;
    line-height: 30px !important;
    height: 30px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
  }

  & > .dropdown.icon {
    top: 50% !important;
    transform: translateY(-50%) !important;
    right: 10px !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  & > .menu {
    border-radius: 20px !important;
    margin-top: 4px !important;
  }
`;

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SearchIcon = styled(Icon)`
  position: absolute !important;
  right: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: #304961 !important;
  pointer-events: none !important;
`;

export default IncomeSource; 